import { ref } from 'vue'

import type { ServiceOverview } from '../api'

export function createServicesOverviewStore(api: {
  overviewList: () => Promise<ServiceOverview[]>
}) {
  const rows = ref<ServiceOverview[]>([])
  const loading = ref(false)

  async function load() {
    loading.value = true
    try {
      rows.value = await api.overviewList()
    } finally {
      loading.value = false
    }
  }

  return { rows, loading, load }
}
